// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '한올바이오파마',
  targetSheetName: '한올CSO보험비보험가격표',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명 (=PRM상 명칭)',
    price: '기준가격 (VAT포함)',
    commissionRate: '수수료율 (VAT포함)',
    commissionNote: '비고1',
  },
  requiredHeaders: [
    '분류',
    '구분',
    '제품명 (=PRM상 명칭)',
    '성분명',
    '수수료율 (VAT포함)',
    '보험코드',
    '처방약호',
    '급여여부',
    '기준가격 (VAT포함)',
    '[오리지널/대조약] (회사명)',
    '비고1',
  ],
});
